import { useEffect, useState } from "react";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { ColumnItem } from "../../../common/models/table";
import { ActionsKey } from "../../../common/models/Actions";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { UserService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { useUserListState, useUserStore } from "./store/UserStore";
import { Loader } from "../../../common/components/Loader/Loader";
import UserForm from "./UserForm";
import { useQueryUserRoleForSelect } from "./core/_hooks";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";

const UserList = () => {
  const { data: stateOptions, isLoading: isLoadingState } =
    useQueryUserRoleForSelect({}, false);

  const { setUserList, userList, actioned, totalItems, setActioned } =
    useUserStore();
  const { pageState, setPageState, resetPageState } = useUserListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cols: ColumnItem[] = [
    {
      key: "email",
      title: "Adresse email",
      dataIndex: "email",
      show: true,
      isCanSort: true,
      searchType: "text",
    },
    {
      key: "fullname",
      title: "Nom et prénom",
      dataIndex: "fullname",
      show: true,
      isCanSort: true,
      searchType: "text",
    },
    {
      key: "userRole",
      title: "Role",
      dataIndex: "userRole",
      show: true,
      nestedKey: "userRole.id",
      searchType: "select",
      searchOptions: stateOptions,
      isLoading: isLoadingState,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchAllUsers(pageState);
  }, [pageState]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onClickOnAdd = () => {
    onShowAddHandler();
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await UserService.getUser(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowAddHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await UserService.deleteUser(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllUsers();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllUsers = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await UserService.getUserList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setUserList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowAddHandler();
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <TitleHeader
        title="Utilisateurs"
        isEnableAdd
        onClickOnAdd={onClickOnAdd}
      />
      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={userList}
            params={pageState}
            onAction={onActionClick}
            isCanEdit={() => true}
            isCanDelete={(row: any) => !row?.userRole?.isRequired}
            onSearch={(search) => {
              handleSetParams(search);
            }}
            onSort={(sort) => {
              handleSetParams(sort);
            }}
            onResetSearch={() => {
              resetPageState();
            }}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
            onChangePage={(e) => handleSetParams(e)}
          />
        </div>
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={actioned?.action === "update" ? "Modification" : "Nouveau"}
          width={"75%"}
        >
          <UserForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};

export default UserList;
